import { isStrictApiMockingEnabled } from '@/utils/runtime-mode.utils'

const defaultChannel = {
  id: 'channel_demo_1',
  name: 'Web Chat',
  type: 'chat'
}

const knowledgeBaseExplorerResults = [
  {
    id: '2c6e72a5-e59c-09ec-95dd-5b606a58c487',
    content: null,
    score: 0.5,
    title: 'New Balance Fresh Foam X More v6 Reflection/ Blue Oyster/ Tangerine Heat',
    payload: {
      id: '2c6e72a5-e59c-09ec-95dd-5b606a58c487',
      score: 0.5,
      product_id: ['475633_10', '475633_10_5', '475633_11', '475633_8_5', '475633_9'],
      link: [
        'https://www.footshop.eu/en/mens-shoes/475633-new-balance-fresh-foam-x-more-v6-reflection-blue-oyster-tangerine-heat.html?size=28',
        'https://www.footshop.eu/en/mens-shoes/475633-new-balance-fresh-foam-x-more-v6-reflection-blue-oyster-tangerine-heat.html?size=29'
      ],
      size: ['42', '42.5', '44', '44.5', '45'],
      brand: 'New Balance',
      color: 'Reflection/ Blue Oyster/ Tangerine Heat',
      price: 170,
      gender: 'male',
      condition: 'new',
      sale_price: '127.49 EUR',
      availability: 'in stock',
      product_type: ["Men's", "Men's shoes", 'New Balance'],
      source_id: '7416779798989261312',
      tenant_id: '7356582791368951277'
    }
  },
  {
    id: 'f855cba5-618a-22ad-a413-59b7f7a33765',
    score: 0.25,
    title: 'Claims',
    content: 'Claims must include a copy of the invoice and completed claim form. Goods should be clean, securely packed, and sent within the warranty period.',
    payload: {
      id: 'f855cba5-618a-22ad-a413-59b7f7a33765',
      score: 0.25,
      content: 'Claims must include a copy of the invoice and completed claim form. Goods should be clean, securely packed, and sent within the warranty period.',
      title: 'Claims',
      source: 'https://www.footshop.eu/en/claims',
      parent_id: '7414608081684549520.json',
      chunk_index: 0,
      tenant_id: '7356582791368951277'
    }
  }
]

const state = {
  // Tools are org-scoped. `usedBy` mirrors what the engine derives by scanning conversation JSON —
  // it exists here only so the 409-while-referenced guard can be exercised without a database.
  tools: [
    {
      id: 'tool_order_status',
      name: 'get_order_status',
      description: 'Look up the delivery status of an order by its order number.',
      parameters: {
        type: 'object',
        properties: {
          orderId: { type: 'string', description: 'The order number, e.g. AB-10293' }
        },
        required: ['orderId'],
        additionalProperties: false
      },
      url: 'https://${variable.shopApiDomain}/orders/${args.orderId}',
      http_verb: 'GET',
      headers: { Authorization: 'Bearer ${variable.shopApiKey}' },
      body: null,
      query_params: null,
      timeout_ms: 10000,
      usedBy: { answers: [{ id: 'a_demo_1', bot_id: 'bot_demo_1', name: 'Opening hours' }], events: [], templates: [] }
    },
    {
      id: 'tool_stock_check',
      name: 'check_stock',
      description: 'Check whether a product is in stock in a given size.',
      parameters: {
        type: 'object',
        properties: {
          sku: { type: 'string', description: 'Product SKU' },
          size: { type: 'string', description: 'Requested size, e.g. 42' }
        },
        required: ['sku'],
        additionalProperties: false
      },
      url: 'https://${variable.shopApiDomain}/stock',
      http_verb: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{"sku": "${args.sku}", "size": "${args.size}"}',
      query_params: null,
      timeout_ms: 8000,
      usedBy: { answers: [], events: [], templates: [] }
    }
  ],
  organization: {
    id: '7426530691171240939',
    name: 'Amio Local',
    is_active: true
  },
  bots: [
    {
      id: 'bot_demo_1',
      name: 'Footwear Bot',
      timezone: 'Europe/Prague',
      type: 'chat',
      language: 'en',
      country: 'GB',
      multi_bot_id: 'market_group_demo',
      market_id: 'market_en_demo',
      is_primary_variant: true,
      nlp_model: 'gpt',
      nlp_model_type: 'gpt',
      is_operator_available: false,
      unknown_intent: {
        intent_platform_id: 'unknown'
      }
    },
    {
      id: 'bot_demo_2',
      name: 'Footwear Bot',
      timezone: 'Europe/Zurich',
      type: 'chat',
      language: 'fr',
      country: 'CH',
      multi_bot_id: 'market_group_demo',
      market_id: 'market_fr_demo',
      primary_bot_id: 'bot_demo_1',
      nlp_model: 'gpt',
      nlp_model_type: 'gpt',
      is_operator_available: false,
      unknown_intent: {
        intent_platform_id: 'unknown'
      }
    }
  ],
  answersByBotId: {
    bot_demo_1: [
      {
        id: 'a_demo_1',
        bot_id: 'bot_demo_1',
        name: 'Opening hours',
        published: true,
        conversation_id: 'a_demo_1',
        conversation_json_hash: 'hash_demo_1',
        multi_bot_item_id: 'a_demo_1',
        conversation_json: {
          states: {
            root: {
              type: 'output',
              actions: ['action_1'],
              transitions: [
                {
                  state: 'ref:global:findIntent',
                  condition: {
                    input: 'userInput',
                    expression: { true: {} }
                  }
                }
              ]
            }
          },
          actions: {
            action_1: {
              type: 'output',
              content: {
                type: 'text',
                payload: 'Hello from isolated mode'
              }
            }
          },
          postbacks: {}
        },
        intent: {
          id: 'intent_demo_1',
          platform_id: 'intent_demo_1',
          description: 'hello'
        },
        request_outcome: {
          id: 'outcome_demo_1',
          name: 'AUTOMATED'
        }
      }
    ],
    bot_demo_2: [
      {
        id: 'a_demo_2',
        bot_id: 'bot_demo_2',
        name: 'Opening hours',
        published: false,
        conversation_id: 'a_demo_2',
        conversation_json_hash: 'hash_demo_2',
        multi_bot_item_id: 'a_demo_1',
        inherits_conversation: false,
        conversation_json: {
          states: {
            root: {
              type: 'output',
              actions: ['action_1'],
              transitions: [
                {
                  state: 'ref:global:findIntent',
                  condition: {
                    input: 'userInput',
                    expression: { true: {} }
                  }
                }
              ]
            }
          },
          actions: {
            action_1: {
              type: 'output',
              content: {
                type: 'text',
                payload: 'Bonjour du mode isolé'
              }
            }
          },
          postbacks: {}
        },
        intent: {
          id: 'intent_demo_2',
          platform_id: 'intent_demo_1',
          description: 'bonjour'
        },
        request_outcome: {
          id: 'outcome_demo_1',
          name: 'AUTOMATED'
        }
      }
    ]
  },
  markets: [
    {
      id: 'market_en_demo',
      name: 'UK - EN',
      language: 'en'
    },
    {
      id: 'market_fr_demo',
      name: 'Swiss - FR',
      language: 'fr'
    }
  ],
  indexGroups: [],
  indexes: [
    {
      id: 'index_demo_knowledge',
      name: 'Footshop UK - EN',
      index_group_id: null,
      market_id: 'market_en_demo',
      provider: 'qdrant',
      sources: [
        { id: 'source_demo_xml', type: 'url', format: 'xml', name: 'Footshop products' },
        { id: 'source_demo_web', type: 'web_scraping', format: 'html', name: 'Footshop help center' }
      ],
      provider_status: { status: 'success' },
      last_index_execution: { status: 'finished', created_on: '2026-08-17T12:00:00.000Z' }
    }
  ],
  multiBots: [
    {
      id: 'market_group_demo',
      name: 'UK - EN',
      is_primary_variant: true,
      primary_bot_id: 'bot_demo_1',
      primary_bot: {
        id: 'bot_demo_1',
        multi_bot_id: 'market_group_demo',
        market_id: 'market_en_demo'
      }
    },
    {
      id: 'market_fr_demo',
      name: 'Swiss - FR',
      is_primary_variant: false,
      primary_bot_id: 'bot_demo_2',
      primary_bot: {
        id: 'bot_demo_2',
        multi_bot_id: 'market_group_demo',
        market_id: 'market_fr_demo'
      }
    }
  ],
  deploymentsByBotId: {
    bot_demo_1: [
      {
        channel: defaultChannel
      }
    ],
    bot_demo_2: [
      {
        channel: defaultChannel
      }
    ]
  },
  analyticsOutcomes: [
    { id: 'outcome_started', name: 'REQUEST_STARTED' },
    { id: 'outcome_yes', name: 'CUSTOMER_ANSWERED_YES' },
    { id: 'outcome_requested', name: 'AGENT_REQUESTED' },
    { id: 'outcome_partially', name: 'CUSTOMER_ANSWERED_PARTIALLY' }
  ],
  analyticsRequestOutcomesByBotId: {
    bot_demo_1: [
      {
        id: 'request_en_1',
        contact_id: 'contact_en_1',
        outcome_id: 'outcome_started',
        outcome_created_on: '2026-07-02T10:00:00.000Z',
        intent_platform_id: 'intent_demo_1',
        channel_id: defaultChannel.id
      },
      {
        id: 'request_en_1',
        contact_id: 'contact_en_1',
        outcome_id: 'outcome_yes',
        outcome_created_on: '2026-07-02T10:02:00.000Z',
        intent_platform_id: 'intent_demo_1',
        channel_id: defaultChannel.id
      },
      {
        id: 'request_en_2',
        contact_id: 'contact_en_2',
        outcome_id: 'outcome_started',
        outcome_created_on: '2026-07-02T11:00:00.000Z',
        intent_platform_id: 'intent_demo_1',
        channel_id: defaultChannel.id
      },
      {
        id: 'request_en_2',
        contact_id: 'contact_en_2',
        outcome_id: 'outcome_requested',
        outcome_created_on: '2026-07-02T11:03:00.000Z',
        intent_platform_id: 'intent_demo_1',
        channel_id: defaultChannel.id
      }
    ],
    bot_demo_2: [
      {
        id: 'request_fr_1',
        contact_id: 'contact_fr_1',
        outcome_id: 'outcome_started',
        outcome_created_on: '2026-07-02T12:00:00.000Z',
        intent_platform_id: 'intent_demo_1',
        channel_id: defaultChannel.id
      },
      {
        id: 'request_fr_1',
        contact_id: 'contact_fr_1',
        outcome_id: 'outcome_partially',
        outcome_created_on: '2026-07-02T12:04:00.000Z',
        intent_platform_id: 'intent_demo_1',
        channel_id: defaultChannel.id
      }
    ]
  }
}

function parseUrlParts(rawUrl = '') {
  const parsed = new URL(rawUrl, 'http://localhost')
  return {
    path: parsed.pathname,
    query: parsed.searchParams
  }
}

function mergeQueryWithConfigParams(query, params = {}) {
  const mergedQuery = new URLSearchParams(query.toString())
  if (!params || typeof params !== 'object') return mergedQuery

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return

    mergedQuery.delete(key)
    if (Array.isArray(value)) {
      if (!value.length) return
      mergedQuery.set(key, value.join(','))
      return
    }

    mergedQuery.set(key, String(value))
  })

  return mergedQuery
}

function buildResponse(config, data, status = 200) {
  return {
    data,
    status,
    statusText: status >= 400 ? 'Error' : 'OK',
    headers: {},
    config,
    request: { mocked: true }
  }
}

function readPayload(config) {
  if (!config || config.data == null) return {}

  if (typeof config.data === 'string') {
    try {
      return JSON.parse(config.data)
    } catch (err) {
      return {}
    }
  }
  return config.data
}

function deepClone(value) {
  return JSON.parse(JSON.stringify(value))
}

function findMockTool(id) {
  return state.tools.find(tool => tool.id === id) || null
}

function toToolResponse(tool) {
  const response = { ...tool }
  // `usedBy` is mock bookkeeping for the delete guard — the real API never returns it
  delete response.usedBy
  const warnings = unusedParameterWarnings(tool)
  return warnings.length ? { ...response, warnings } : response
}

// The two engine-side validations that change what the user sees, reproduced so the mocked UI
// behaves like the real one. Everything else the engine validates simply cannot be triggered from
// the form.
function validateMockTool(config, tool) {
  const declared = Object.keys((tool.parameters && tool.parameters.properties) || {})
  const used = usedArgumentNames(tool)
  const undeclared = used.filter(name => !declared.includes(name))
  if (undeclared.length) {
    throw buildError(config, `The request uses \${args.${undeclared.join('}, \${args.')}} but that parameter is not declared`, 422)
  }
}

function unusedParameterWarnings(tool) {
  const declared = Object.keys((tool.parameters && tool.parameters.properties) || {})
  const used = usedArgumentNames(tool)
  const unused = declared.filter(name => !used.includes(name))
  return unused.length ? [`Declared but never used in the request: ${unused.join(', ')}`] : []
}

function usedArgumentNames(tool) {
  const searchable = JSON.stringify([tool.url, tool.body, tool.headers, tool.query_params])
  const matches = searchable.match(/\$\{args\.[^}]+\}/g) || []
  return [...new Set(matches.map(match => match.slice('${args.'.length, -1)))]
}

// Stands in for a real HTTP call. Substitutes the same way the engine does so the echoed request is
// honest, then returns a canned body — there is no server to call in isolated mode.
function runMockTool(config, tool, payload) {
  const args = (payload && payload.args) || {}
  const required = (tool.parameters && tool.parameters.required) || []
  const missing = required.filter(name => !args[name])
  if (missing.length) throw buildError(config, `Fill in ${missing.join(', ')} — it is required`, 422)

  const declared = Object.keys((tool.parameters && tool.parameters.properties) || {})
  const unknown = Object.keys(args).filter(name => !declared.includes(name))
  if (unknown.length) throw buildError(config, `${unknown.join(', ')} is not a parameter of this tool`, 422)

  const substitute = text => (text || '').replace(/\$\{(args|variable)\.([^}]+)\}/g, (match, kind, name) =>
    kind === 'args' ? (args[name] || '') : `demo-${name}`)

  const substituteMap = map => Object.fromEntries(
    Object.entries(map || {}).map(([key, value]) => [substitute(key), substitute(String(value))])
  )

  return {
    request: {
      method: tool.http_verb,
      url: encodeURI(substitute(tool.url)),
      headers: substituteMap(tool.headers),
      query_params: substituteMap(tool.query_params),
      body: tool.body ? substitute(tool.body) : null
    },
    response: {
      http_status: 200,
      body: { ok: true, note: 'Mocked response — isolated mode does not make real HTTP calls.', received: args },
      duration_ms: 42,
      error: false
    }
  }
}

function createMockTool(config, payload) {
  const tool = { ...payload, id: `tool_${Date.now()}`, usedBy: { answers: [], events: [], templates: [] } }
  validateMockTool(config, tool)
  if (state.tools.some(candidate => candidate.name === tool.name)) {
    throw buildError(config, `Tool with the name "${tool.name}" already exists in this organization`, 409)
  }
  state.tools.push(tool)
  return toToolResponse(tool)
}

function updateMockTool(config, tool, payload) {
  const merged = { ...tool, ...payload }
  validateMockTool(config, merged)
  if (state.tools.some(candidate => candidate.id !== tool.id && candidate.name === merged.name)) {
    throw buildError(config, `Tool with the name "${merged.name}" already exists in this organization`, 409)
  }
  state.tools = state.tools.map(candidate => candidate.id === tool.id ? merged : candidate)
  return toToolResponse(merged)
}

function buildError(config, message, status = 500) {
  const error = new Error(message)
  error.config = config
  error.response = {
    status,
    data: {
      errors: [{ message }]
    },
    config
  }
  return error
}

function findBot(botId) {
  return state.bots.find(bot => bot.id === botId)
}

function listBots() {
  return state.bots.map(bot => ({ ...bot }))
}

function listMultiBots() {
  return state.multiBots.map(multiBot => deepClone(multiBot))
}

function listMarkets() {
  return state.markets.map(market => ({ ...market }))
}

function listIndexGroups() {
  return state.indexGroups.map(indexGroup => ({ ...indexGroup }))
}

function createIndexGroup(payload = {}) {
  const indexGroup = {
    id: `index_group_${Date.now()}_${state.indexGroups.length}`,
    name: payload.name || 'New Knowledge Base Group'
  }
  state.indexGroups.push(indexGroup)
  return { ...indexGroup }
}

function listIndexes() {
  return state.indexes.map(index => deepClone(index))
}

function createIndex(payload = {}) {
  const createdAt = new Date().toISOString()
  const indexId = `index_${Date.now()}_${state.indexes.length}`
  const index = {
    ...deepClone(payload),
    id: indexId,
    name: payload.name || 'New Knowledge Base',
    index_group_id: payload.index_group_id || null,
    market_id: payload.market_id || null,
    provider: payload.provider || 'qdrant',
    sources: (payload.sources || []).map((source, position) => ({
      ...source,
      id: source.id || `${indexId}_source_${position}`
    })),
    provider_status: { status: 'success' },
    last_index_execution: {
      status: 'finished',
      created_on: createdAt
    }
  }
  state.indexes.push(index)
  return deepClone(index)
}

function searchKnowledgeBase(indexId, payload = {}) {
  const index = state.indexes.find(item => item.id === indexId)
  if (!index) return null

  const topN = Number.isInteger(payload.top_n) && payload.top_n > 0 ? payload.top_n : 10
  const response = {
    query: payload.query || '',
    provider: index.provider,
    results: deepClone(knowledgeBaseExplorerResults.slice(0, topN))
  }

  if (payload.mode === 'rag') {
    Object.assign(response, {
      reformulated_query: payload.query || '',
      filterable_fields: [
        { field: 'brand', type: 'keyword', collection: 'products', values: ['New Balance'] }
      ],
      proposed_filters: [{ field: 'brand', value: 'New Balance' }],
      applied_filters: { must: [{ key: 'brand', match: { value: 'New Balance' } }] },
      fell_back: false
    })
  }

  return response
}

function listAnswers(botId) {
  return (state.answersByBotId[botId] || []).map(answer => deepClone(answer))
}

function getAnswer(botId, answerId) {
  const answers = state.answersByBotId[botId] || []
  const answer = answers.find(item => item.id === answerId)
  return answer ? deepClone(answer) : null
}

function listAnswerVariants(botId, answerId) {
  const sourceAnswer = getAnswer(botId, answerId)
  if (!sourceAnswer) return []

  const multiBotItemId = sourceAnswer.multi_bot_item_id || sourceAnswer.id

  return Object.values(state.answersByBotId)
    .flat()
    .filter(answer => (answer.multi_bot_item_id || answer.id) === multiBotItemId)
    .map(answer => deepClone(answer))
}

function updateAnswer(botId, answerId, patchData = {}) {
  const answers = state.answersByBotId[botId] || []
  const index = answers.findIndex(item => item.id === answerId)
  if (index === -1) return null

  const answer = answers[index]
  const updated = { ...answer }

  if (patchData.name !== undefined) updated.name = patchData.name
  if (patchData.published !== undefined) updated.published = patchData.published
  if (patchData.conversation_json !== undefined) {
    updated.conversation_json = deepClone(patchData.conversation_json)
    updated.conversation_json_hash = patchData.conversation_json_hash || `hash_${Date.now()}`
  }

  answers[index] = updated
  state.answersByBotId[botId] = answers
  return deepClone(updated)
}

function createAnswer(botId, payload = {}) {
  const id = `a_demo_${Date.now()}`
  const intentId = `intent_demo_${Date.now()}`
  const conversationJson = payload.conversation_json || {
    states: {},
    actions: {},
    postbacks: {}
  }

  const answer = {
    id,
    name: payload.name || 'New Answer',
    published: false,
    conversation_id: id,
    conversation_json_hash: `hash_${Date.now()}`,
    conversation_json: conversationJson,
    intent: {
      id: intentId,
      platform_id: intentId,
      description: ''
    },
    request_outcome: {
      id: 'outcome_demo_1',
      name: 'AUTOMATED'
    }
  }

  const answers = state.answersByBotId[botId] || []
  answers.unshift(answer)
  state.answersByBotId[botId] = answers
  return deepClone(answer)
}

function getIntent(intentId) {
  for (const answers of Object.values(state.answersByBotId)) {
    const answer = answers.find(item => item.intent?.id === intentId)
    if (answer) return deepClone(answer.intent)
  }
  return null
}

function updateIntent(intentId, patchData = {}) {
  for (const botId of Object.keys(state.answersByBotId)) {
    const answers = state.answersByBotId[botId]
    const index = answers.findIndex(item => item.intent?.id === intentId)
    if (index === -1) continue

    const updatedIntent = {
      ...answers[index].intent
    }
    if (patchData.description !== undefined) updatedIntent.description = patchData.description

    answers[index] = {
      ...answers[index],
      intent: updatedIntent
    }
    state.answersByBotId[botId] = answers
    return deepClone(updatedIntent)
  }
  return null
}

function upsertBot(botId, patchData = {}) {
  const index = state.bots.findIndex(bot => bot.id === botId)
  if (index === -1) return null
  state.bots[index] = { ...state.bots[index], ...patchData }
  return { ...state.bots[index] }
}

function removeBot(botId) {
  const index = state.bots.findIndex(bot => bot.id === botId)
  if (index === -1) return false
  state.bots.splice(index, 1)
  delete state.deploymentsByBotId[botId]
  delete state.answersByBotId[botId]
  return true
}

function createBotFromPayload(payload = {}) {
  const primaryVariant = payload.primary_variant || {}
  const timezone = primaryVariant.timezone || payload.timezone || 'Europe/Prague'
  const type = primaryVariant.type || payload.type || 'chat'
  const language = primaryVariant.language || payload.language || 'en'
  const nlpModelType = primaryVariant.nlp_model_type || payload.nlp_model_type || 'gpt'
  const id = `bot_${Date.now()}`
  const bot = {
    id,
    name: payload.name || 'New Bot',
    timezone,
    type,
    language,
    country: primaryVariant.country || payload.country,
    nlp_model: nlpModelType
  }
  state.bots.unshift(bot)
  state.deploymentsByBotId[id] = []
  return { ...bot }
}

function convertBotToMultiBot(payload = {}) {
  const botId = payload.primary_variant?.bot_id
  const marketId = payload.primary_variant?.market_id
  const bot = state.bots.find(item => item.id === botId)
  if (!bot) {
    const err = new Error(`Cannot use bot with id "${botId}". This bot does not exist in the organization.`)
    err.response = { status: 422, data: { message: err.message } }
    throw err
  }
  if (bot.multi_bot_id) {
    const err = new Error(`Cannot use bot with id "${botId}". This bot is already associated with a multi-bot.`)
    err.response = { status: 422, data: { message: err.message } }
    throw err
  }

  const multiBotId = `multi_bot_${Date.now()}`
  bot.multi_bot_id = multiBotId
  bot.market_id = marketId
  bot.is_primary_variant = true
  bot.primary_bot_id = botId

  const multiBot = {
    id: multiBotId,
    name: payload.name || bot.name,
    is_primary_variant: true,
    primary_bot_id: botId,
    primary_bot: deepClone(bot)
  }
  state.multiBots.push(multiBot)
  return deepClone(multiBot)
}

function listDeployments(botId) {
  return (state.deploymentsByBotId[botId] || []).map(item => ({ ...item }))
}

function listAnalyticsRequestOutcomes(botIds = [], {
  channelIds = [],
  dateFrom = null,
  dateTo = null
} = {}) {
  const selectedBotIds = botIds.length ? botIds : state.bots.map(({ id }) => id)
  const selectedChannelIds = new Set(channelIds)
  const fromTimestamp = dateFrom ? +new Date(dateFrom) : null
  const toTimestamp = dateTo ? +new Date(dateTo) : null

  return selectedBotIds
    .flatMap(botId => state.analyticsRequestOutcomesByBotId[botId] || [])
    .filter(requestOutcome => {
      const timestamp = +new Date(requestOutcome.outcome_created_on)
      if (selectedChannelIds.size && !selectedChannelIds.has(requestOutcome.channel_id)) return false
      if (fromTimestamp && timestamp < fromTimestamp) return false
      if (toTimestamp && timestamp > toTimestamp) return false
      return true
    })
    .sort((a, b) => {
      if (a.id === b.id) {
        return +new Date(a.outcome_created_on) - +new Date(b.outcome_created_on)
      }

      return String(a.id).localeCompare(String(b.id))
    })
    .map(requestOutcome => deepClone(requestOutcome))
}

function listAnalyticsOutcomes(requestOutcomes = []) {
  const outcomeIds = new Set(requestOutcomes.map(({ outcome_id }) => outcome_id))
  return state.analyticsOutcomes
    .filter(({ id }) => outcomeIds.has(id))
    .map(outcome => ({ ...outcome }))
}

function addDeployment(botId, channelId) {
  const list = state.deploymentsByBotId[botId] || []
  const exists = list.some(item => item.channel.id === channelId)
  if (!exists) {
    list.push({
      channel: {
        id: channelId,
        name: `Channel ${channelId}`,
        type: 'chat'
      }
    })
  }
  state.deploymentsByBotId[botId] = list
  return listDeployments(botId)
}

function createDeployment(botId, payload = {}) {
  const channelId = `channel_${Date.now()}`
  const channelName = payload.name || `Channel ${channelId}`
  const channelType = payload.type || 'amio_chat'
  const list = state.deploymentsByBotId[botId] || []
  const deployment = {
    channel: {
      id: channelId,
      name: channelName,
      type: channelType
    }
  }
  list.push(deployment)
  state.deploymentsByBotId[botId] = list
  return { ...deployment }
}

function removeDeployment(botId, channelId) {
  const list = state.deploymentsByBotId[botId] || []
  state.deploymentsByBotId[botId] = list.filter(item => item.channel.id !== channelId)
}

function handleOrgApi(config, method, path) {
  if (method === 'get' && path === '/organizations') {
    return buildResponse(config, state.organization)
  }
  return null
}

function handleEngineApi(config, method, path, query) {
  if (method === 'get' && path === '/utils/preview-xml-feed') {
    return buildResponse(config, {
      item_tag: query.get('itemTag') || 'Product',
      item_tag_data: {
        Brand: 'FabDecor',
        Category: 'Home>Home Decor>Pillows|Back In Stock',
        Category_ID: '298|511',
        Color: 'Blue',
        Color_Family: 'Blue',
        Date_Created: '2026-08-13',
        Description: 'Sociosqu facilisis duis ...',
        Inventory_Count: '42',
        Name: 'On Cloud Nine Pillow',
        Price: '24.99',
        Product_ID: '7631',
        Product_URL: 'https://www.domain.com/product/heh-9133',
        Retail_Price: '24.99',
        Search_Keywords: 'lorem, ipsum, dolor, ...',
        SKU: 'HEH-9133',
        Thumbnail_URL: 'https://www.domain.com/images/heh-9133_600x600.png'
      }
    })
  }

  if (method === 'get' && path === '/analytics/request-outcomes') {
    const botIds = (query.get('botIds') || '').split(',').filter(Boolean)
    const channelIds = (query.get('channelIds') || '').split(',').filter(Boolean)
    const requestOutcomes = listAnalyticsRequestOutcomes(botIds, {
      channelIds,
      dateFrom: query.get('dateFrom'),
      dateTo: query.get('dateTo')
    })

    return buildResponse(config, {
      requestOutcomes,
      outcomes: listAnalyticsOutcomes(requestOutcomes)
    })
  }

  if (method === 'get' && path === '/bots') {
    return buildResponse(config, listBots())
  }

  if (method === 'get' && path === '/variables') {
    return buildResponse(config, [])
  }

  if (path === '/tools') {
    if (method === 'get') return buildResponse(config, state.tools.map(toToolResponse))
    if (method === 'post') return buildResponse(config, createMockTool(config, readPayload(config)), 201)
  }

  const toolTestMatch = path.match(/^\/tools\/([^/]+)\/test$/)
  if (toolTestMatch && method === 'post') {
    const tool = findMockTool(toolTestMatch[1])
    if (!tool) throw buildError(config, `Mock tool not found: ${toolTestMatch[1]}`, 404)
    return buildResponse(config, runMockTool(config, tool, readPayload(config)))
  }

  const toolReferencesMatch = path.match(/^\/tools\/([^/]+)\/references$/)
  if (toolReferencesMatch && method === 'get') {
    const tool = findMockTool(toolReferencesMatch[1])
    if (!tool) throw buildError(config, `Mock tool not found: ${toolReferencesMatch[1]}`, 404)
    return buildResponse(config, tool.usedBy)
  }

  const toolMatch = path.match(/^\/tools\/([^/]+)$/)
  if (toolMatch) {
    const tool = findMockTool(toolMatch[1])
    if (!tool) throw buildError(config, `Mock tool not found: ${toolMatch[1]}`, 404)

    if (method === 'get') return buildResponse(config, toToolResponse(tool))
    if (method === 'patch') return buildResponse(config, updateMockTool(config, tool, readPayload(config)))
    if (method === 'delete') {
      const { answers, events, templates } = tool.usedBy
      if (answers.length || events.length || templates.length) {
        throw buildError(config, 'Tool is being used in a conversation!', 409)
      }
      state.tools = state.tools.filter(candidate => candidate.id !== tool.id)
      return buildResponse(config, null, 204)
    }
  }

  if (method === 'get' && path === '/deployments') {
    const deployments = Object.keys(state.deploymentsByBotId).reduce((byBot, botId) => {
      const botDeployments = listDeployments(botId)
      if (botDeployments.length > 0) byBot[botId] = botDeployments
      return byBot
    }, {})
    return buildResponse(config, { deployments, failedBotIds: [] })
  }

  const intentMatch = path.match(/^\/intents\/([^/]+)$/)
  if (intentMatch) {
    const intentId = intentMatch[1]
    if (method === 'get') {
      const intent = getIntent(intentId)
      if (!intent) throw buildError(config, `Mock intent not found: ${intentId}`, 404)
      return buildResponse(config, intent)
    }
    if (method === 'patch') {
      const updatedIntent = updateIntent(intentId, readPayload(config))
      if (!updatedIntent) throw buildError(config, `Mock intent not found: ${intentId}`, 404)
      return buildResponse(config, updatedIntent)
    }
  }

  const botMatch = path.match(/^\/bots\/([^/]+)$/)
  if (botMatch) {
    const botId = botMatch[1]
    if (method === 'get') {
      const bot = findBot(botId)
      if (!bot) throw buildError(config, `Mock bot not found: ${botId}`, 404)
      return buildResponse(config, { ...bot })
    }
    if (method === 'patch') {
      const updated = upsertBot(botId, readPayload(config))
      if (!updated) throw buildError(config, `Mock bot not found: ${botId}`, 404)
      return buildResponse(config, updated)
    }
    if (method === 'delete') {
      if (!removeBot(botId)) throw buildError(config, `Mock bot not found: ${botId}`, 404)
      return buildResponse(config, {}, 204)
    }
  }

  if (method === 'post' && path === '/bots') {
    return buildResponse(config, createBotFromPayload(readPayload(config)), 201)
  }

  if (method === 'get' && path === '/markets') {
    return buildResponse(config, listMarkets())
  }

  if (method === 'get' && path === '/index-groups') {
    return buildResponse(config, listIndexGroups())
  }

  if (method === 'post' && path === '/index-groups') {
    return buildResponse(config, createIndexGroup(readPayload(config)), 201)
  }

  if (method === 'get' && path === '/indexes') {
    return buildResponse(config, listIndexes())
  }

  const indexSearchMatch = path.match(/^\/indexes\/([^/]+)\/search$/)
  if (indexSearchMatch && method === 'post') {
    const result = searchKnowledgeBase(indexSearchMatch[1], readPayload(config))
    if (!result) throw buildError(config, `Mock knowledge base not found: ${indexSearchMatch[1]}`, 404)
    return buildResponse(config, result)
  }

  if (method === 'post' && path === '/indexes') {
    return buildResponse(config, createIndex(readPayload(config)), 201)
  }

  if (method === 'post' && path === '/markets') {
    const payload = readPayload(config)
    return buildResponse(config, {
      id: `market_${Date.now()}`,
      name: payload.name,
      language: payload.language
    }, 201)
  }

  if (method === 'post' && path === '/multi-bots') {
    const payload = readPayload(config)
    if (payload.primary_variant?.bot_id) {
      try {
        return buildResponse(config, convertBotToMultiBot(payload), 201)
      } catch (err) {
        throw buildError(config, err.message, 422)
      }
    }
    return buildResponse(config, createBotFromPayload(payload), 201)
  }

  if (method === 'get' && path === '/multi-bots') {
    return buildResponse(config, listMultiBots())
  }

  const cloneMatch = path.match(/^\/bots\/([^/]+)\/clone$/)
  if (cloneMatch && method === 'post') {
    const sourceBotId = cloneMatch[1]
    const sourceBot = findBot(sourceBotId)
    if (!sourceBot) throw buildError(config, `Mock source bot not found: ${sourceBotId}`, 404)

    const payload = readPayload(config)
    return buildResponse(config, createBotFromPayload({
      ...sourceBot,
      ...payload,
      type: sourceBot.type
    }), 201)
  }

  const deploymentsMatch = path.match(/^\/bots\/([^/]+)\/deployments$/)
  if (deploymentsMatch) {
    const botId = deploymentsMatch[1]
    if (method === 'get') return buildResponse(config, listDeployments(botId))
    if (method === 'post') {
      const payload = readPayload(config)
      return buildResponse(config, createDeployment(botId, payload), 201)
    }
    if (method === 'put') {
      const payload = readPayload(config)
      const channelId = payload.channel_id
      if (!channelId) throw buildError(config, 'Mock deployment requires channel_id', 400)
      return buildResponse(config, addDeployment(botId, channelId))
    }
    if (method === 'delete') {
      const channelId = query.get('channelId')
      if (!channelId) throw buildError(config, 'Mock deployment delete requires channelId query', 400)
      removeDeployment(botId, channelId)
      return buildResponse(config, {}, 204)
    }
  }

  const templatesMatch = path.match(/^\/bots\/([^/]+)\/templates$/)
  if (templatesMatch && method === 'get') {
    return buildResponse(config, [])
  }

  const answersMatch = path.match(/^\/bots\/([^/]+)\/answers$/)
  if (answersMatch && method === 'get') {
    const botId = answersMatch[1]
    return buildResponse(config, listAnswers(botId))
  }
  if (answersMatch && method === 'post') {
    const botId = answersMatch[1]
    const created = createAnswer(botId, readPayload(config))
    return buildResponse(config, created, 201)
  }

  const answerDetailMatch = path.match(/^\/bots\/([^/]+)\/answers\/([^/]+)$/)
  if (answerDetailMatch && method === 'get') {
    const botId = answerDetailMatch[1]
    const answerId = answerDetailMatch[2]
    const answer = getAnswer(botId, answerId)
    if (!answer) throw buildError(config, `Mock answer not found: ${answerId}`, 404)
    return buildResponse(config, answer)
  }
  if (answerDetailMatch && method === 'patch') {
    const botId = answerDetailMatch[1]
    const answerId = answerDetailMatch[2]
    const payload = readPayload(config)
    const updated = updateAnswer(botId, answerId, payload)
    if (!updated) throw buildError(config, `Mock answer not found: ${answerId}`, 404)
    return buildResponse(config, updated)
  }

  const answerVariantsMatch = path.match(/^\/bots\/([^/]+)\/answers\/([^/]+)\/variants$/)
  if (answerVariantsMatch && method === 'get') {
    const botId = answerVariantsMatch[1]
    const answerId = answerVariantsMatch[2]
    return buildResponse(config, listAnswerVariants(botId, answerId))
  }

  const answerReferencedConversationsMatch = path.match(/^\/bots\/([^/]+)\/answers\/([^/]+)\/referenced-conversations$/)
  if (answerReferencedConversationsMatch && method === 'get') {
    return buildResponse(config, {})
  }

  const variablesMatch = path.match(/^\/bots\/([^/]+)\/variables$/)
  if (variablesMatch && method === 'put') {
    return buildResponse(config, { refs: readPayload(config) })
  }

  return null
}

function handleCommunicatorApi(config) {
  throw buildError(config, 'Communicator mock route not implemented yet', 501)
}

export function createMockAdapter(config, clientName) {
  const method = (config.method || 'get').toLowerCase()
  const { path, query: urlQuery } = parseUrlParts(config.url || '')
  const query = mergeQueryWithConfigParams(urlQuery, config.params)
  const strict = isStrictApiMockingEnabled()

  let response = null
  if (clientName === 'org') response = handleOrgApi(config, method, path, query)
  if (clientName === 'engine') response = handleEngineApi(config, method, path, query)
  if (clientName === 'communicator') response = handleCommunicatorApi(config, method, path, query)

  if (response) return response
  if (!strict) return null

  throw buildError(
    config,
    `Missing API mock for [${clientName}] ${method.toUpperCase()} ${path}`,
    501
  )
}
